import type { ChatbotLogger } from '../types';

/**
 * Triggers Applied Labs' `.show()` method. Which shows the trigger button.
 */
export function showChatbot(logger: ChatbotLogger | Console = console): void {
  try {
    window.applied?.show?.();
    logger.info?.({
      type: 'client',
      context: 'Chatbot - showChatbot',
      message: 'show() called',
      sessionId: undefined,
    });
  } catch (err) {
    logger.error?.(
      {
        type: 'client',
        context: 'Chatbot - showChatbot',
        message: 'Failed to show()',
        sessionId: undefined,
      },
      { error: err },
    );
  }
}

/**
 * Triggers Applied Labs' `.hide()` method. Which hides the trigger button.
 */
export function hideChatbot(logger: ChatbotLogger | Console = console): void {
  try {
    window.applied?.hide?.();
    logger.info?.({
      type: 'client',
      context: 'Chatbot - hideChatbot',
      message: 'hide() called',
      sessionId: undefined,
    });
  } catch (err) {
    logger.error?.(
      {
        type: 'client',
        context: 'Chatbot - hideChatbot',
        message: 'Failed to hide()',
        sessionId: undefined,
      },
      { error: err },
    );
  }
}

/**
 * Sets the chatbot open or closed programmatically.
 */
export const setOpen = (open: boolean, logger: ChatbotLogger | Console = console): void => {
  try {
    window.applied?.setOpen?.(open);
    logger.info?.({
      type: 'client',
      context: 'Chatbot - setOpen',
      message: 'setOpen() called',
      sessionId: undefined,
    });
  } catch (err) {
    logger.error?.(
      {
        type: 'client',
        context: 'Chatbot - setOpen',
        message: 'Failed to setOpen()',
        sessionId: undefined,
      },
      { error: err },
    );
  }
};
